import modalCookie from './components/modal-cookie/modal-cookie';

modalCookie();